import React from 'react';

const MicrosoftOfficeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            height="70"
            width="70"
            viewBox="0 0 2075 2499.8"
        >
            <path
                fill="#eb3c00"
                d="M0 2016.6V496.8L1344.4 0 2075 233.7v2045.9l-730.6 220.3L0 2016.6l1344.4 161.8V409.2L467.6 613.8v1198.3z"
            ></path>
        </svg>
    );
};

export default MicrosoftOfficeIcon;